module.exports = __webpack_public_path__ + "img/davisonlifesciences-h-474x356.9a1df348.jpg";